<template>
  <div
    class="tab-pane fade"
    id="nav-RecentCoaching"
    role="tabpanel"
    aria-labelledby="nav-RecentCoaching-tab"
    tabindex="0"
  >
    <div class="table-responsive table-datatble">
      <table class="table table-borderless dashboard-card-table">
        <thead class="thead-light">
          <tr>
            <th>Court Name</th>
            <th>Invoice</th>
            <th>Date & Time</th>
            <th>Payment</th>
            <th>Paid On</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="record in Recent_Coaching" :key="record.id">
            <td>
              <h2 class="table-avatar">
                <a
                  href="javascript:void(0);"
                  data-bs-toggle="modal"
                  data-bs-target="#upcoming-coach"
                  class="avatar avatar-sm flex-shrink-0"
                >
                  <img
                    class="avatar-img"
                    :src="require(`@/assets/img/featured/${record.Image}`)"
                    alt="Venue"
                  />
                </a>
                <span class="table-head-name flex-grow-1">
                  <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#upcoming-coach">{{
                    record.CourtName
                  }}</a>
                  <span>{{ record.Booking }}</span>
                </span>
              </h2>
            </td>
            <td>{{ record.Invoice }}</td>
            <td>
              <p>{{ record.Date }}</p>
              <p>{{ record.Time }}</p>
            </td>
            <td>
              <h6>{{ record.Payment }}</h6>
            </td>
            <td>{{ record.PaidOn }}</td>
            <td class="paid-edit">
              <span><i class="feather-edit"></i> {{ record.Status }}</span>
            </td>
            <td>
              <div class="dropdown dropdown-action">
                <a
                  href="javascript:void(0);"
                  class="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="fas fa-ellipsis"></i
                ></a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item" href="javascript:void(0);">
                    <i class="feather-download"></i> Download
                  </a>
                  <a class="dropdown-item" href="javascript:void(0);">
                    <i class="feather-trash"></i> Delete
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Recent_Coaching from "@/assets/json/recent-coaching.json";
export default {
  data() {
    return {
      Recent_Coaching: Recent_Coaching,
    };
  },
};
</script>
